import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-dad06003.js";
const r = {}, c = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, n = /* @__PURE__ */ o("path", {
  fill: "currentColor",
  d: "M9.104 2.9a1 1 0 0 1 1.794 0l1.93 3.91l4.317.628a1 1 0 0 1 .554 1.706l-3.124 3.044l.738 4.3a1 1 0 0 1-1.451 1.054l-3.86-2.03l-3.862 2.03a1 1 0 0 1-1.45-1.055l.737-4.299l-3.124-3.044a1 1 0 0 1 .554-1.706l4.317-.627l1.93-3.912Z"
}, null, -1), s = [
  n
];
function _(a, i) {
  return e(), t("svg", c, s);
}
const h = /* @__PURE__ */ l(r, [["render", _]]);
export {
  h as default
};
